import { useQuery } from '@tanstack/react-query'
import { getShowById } from 'api/show'

export const useShowById = (id: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['show', id],
        queryFn: () => getShowById(id),
        enabled: !!id,
    })

    return {
        data,
        isLoading,
        error,
    }
}
